import { titleCase } from 'title-case';

import {
  CheckMetadata,
  CheckMetadataItem,
  CheckMetadataItemType,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import ComparisonResultTooltip from 'dashboard/components/ComparisonResultTooltip';
import { CheckStatus, DatabaseBusinessAssociatedPersonsComparison } from 'dashboard/models/check';

export const computeDatabaseBusinessAssociatedPersonsComparisonMetadata = (
  check: DatabaseBusinessAssociatedPersonsComparison,
): CheckMetadata => {
  const checkMetadata = check.metadata;
  const matchGroupResults = checkMetadata?.['results'] || [];

  const metadata: CheckMetadataItem[] = matchGroupResults.reduce((acc, matchGroupResult) => {
    // NB: Surface the match requirement result for the associated person's full name.
    // TODO: revisit once we decide we want to support comparisons on attributes other than just the full name.
    const matchRequirementResultNameFull = matchGroupResult?.['match-requirement-results']?.find(
      (result) => result?.properties?.includes('name_full'),
    );

    if (!matchRequirementResultNameFull) {
      return acc;
    }

    const {
      'best-result': bestResult,
      'claimed-attributes': claimedAttributes,
      'normalized-extracted-attributes': normalizedExtractedAttributes,
      'attribute-comparison-results': attributeComparisonResults,
    } = matchRequirementResultNameFull;

    const metadataItems = [
      {
        label: 'Input',
        value: claimedAttributes[0],
      },
    ];

    if (check.status === CheckStatus.Passed) {
      metadataItems.push({
        label: 'Record',
        value: normalizedExtractedAttributes[0],
      });
    }

    metadataItems.push({
      label: 'Match Result',
      value: (
        <>
          {titleCase(bestResult)}
          <ComparisonResultTooltip attributeComparisonResults={attributeComparisonResults} />
        </>
      ),
    });

    acc.push({
      type: CheckMetadataItemType.Group,
      heading: {
        title: 'Full Name',
      },
      items: metadataItems,
    });

    return acc;
  }, [] as CheckMetadataItem[]);

  return {
    metadata,
    hideIfVerificationPassed: false,
  };
};
